import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";


const ResReservation1 = (props) => {

	const { t } = props


	React.useEffect(() => {
		if (props.data.length == 1) {
			props.next(props.data[0].id);
		}
	}, [])

	return (
		<div>
			<header class="inner-pages subpages">
				<a onClick={() => props.goBack()} class="button-back"></a>
				<div class="heading align-center">
					<p class="bold">{t('resReservation.heading1')}</p>
				</div>
			</header>
			<section class="widgets">
				<div class="row margin-bottom-2">
					<div class="col col-2">
						{
							props.data.map((resort) => {
								return (
									<>
										{resort.isActive &&
											<a onClick={() => props.next(resort.id)} className="tile-sm thumbnails tile-container">
												<div class="thumb-img">
													{resort.image ? <img src={resort.image} />
														: <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.97 51.05" style={{ fill: "#010101" }}><defs></defs>
															<g id="Layer_1-2" data-name="Layer 1">
																<path class="cls-1" d="m45.02,51.05c-14.13-.02-25.58-11.47-25.6-25.6,1.34-33.94,49.86-33.92,51.2,0-.02,14.13-11.47,25.58-25.6,25.6Zm0-46.93c-11.78.01-21.32,9.56-21.33,21.33,1.12,28.28,41.55,28.27,42.67,0-.01-11.78-9.56-21.32-21.33-21.33Zm17.07,21.33c0-1.18-.96-2.13-2.13-2.13s-2.13.96-2.13,2.13c-.54,16.92-25.06,16.91-25.6,0,0-7.07,5.73-12.79,12.8-12.8,1.18,0,2.13-.96,2.13-2.13s-.96-2.13-2.13-2.13c-9.42.01-17.06,7.65-17.07,17.07.8,22.59,33.34,22.58,34.13,0Z" />
																<path class="cls-1" d="m15.24,5.21c-.94,0-1.69.76-1.69,1.69v10.16c0,2.14-1.36,4.05-3.39,4.77V6.9c0-.94-.76-1.69-1.69-1.69s-1.69.76-1.69,1.69v14.93c-2.02-.71-3.38-2.62-3.39-4.77V6.9c0-.94-.76-1.69-1.69-1.69s-1.69.76-1.69,1.69v10.16c0,4.02,2.83,7.49,6.77,8.3v18.79c0,.94.76,1.69,1.69,1.69s1.69-.76,1.69-1.69v-18.79c3.94-.81,6.77-4.27,6.77-8.3V6.9c0-.94-.76-1.69-1.69-1.69Z" />
																<path class="cls-1" d="m84.96,22.09c-.15,6.52-3.27,12.61-8.47,16.55v5.46c0,.94-.76,1.69-1.69,1.69s-1.69-.76-1.69-1.69V8.55c-.03-1.3.72-2.49,1.91-3.02,1.37-.56,2.93-.25,3.99.78,3.93,4.31,6.05,9.96,5.95,15.79Z" />
															</g>
														</svg>}
												</div>
												<div class="thumb-text">
													<p class="thumb-heading">{resort.description}</p>
												</div>
											</a>
										}
									</>
								)
							})
						}
					</div>
				</div>
			</section>
		</div>
	)
}

const mapStateToProps = state => {
	return {
		installedAppVersion: state.store.installedAppVersion,
		installedAppBuildNo: state.store.installedAppBuildNo,
	}
}

export default connect(mapStateToProps, {})(withTranslation('translations')(ResReservation1));